import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesExplorerActivity: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-explorer-activity`),
};

export default pagesExplorerActivity;
